import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["correction", "taps"];
import { createSlice } from '@reduxjs/toolkit';
import { ActionSearch } from "./actions";
import { STEP } from "../../../components/Search/utils/constants";
var initialState = {
  isLoading: false,
  error: {
    code: null,
    message: ''
  },
  query: '',
  correction: '',
  anyQueryData: {},
  taps: [],
  step: STEP.recently,
  isOpenSidebar: false,
  isWebView: false
};
var searchSlice = createSlice({
  name: 'searchSlice',
  initialState: initialState,
  reducers: {},
  extraReducers: function extraReducers(builder) {
    builder.addCase(ActionSearch.fetchSearchData.pending, function (state) {
      state.error = {
        code: null,
        message: ''
      };
      state.isLoading = true;
    }).addCase(ActionSearch.fetchSearchData.fulfilled, function (state, action) {
      var _action$payload = action.payload,
        correction = _action$payload.correction,
        taps = _action$payload.taps,
        resultBlocks = _objectWithoutProperties(_action$payload, _excluded);
      state.taps = taps;
      state.correction = correction;
      state.anyQueryData = resultBlocks;
      state.isLoading = false;
    }).addCase(ActionSearch.fetchSearchData.rejected, function (state, action) {
      var _action$error;
      state.anyQueryData = {};
      var _ref = action === null || action === void 0 ? void 0 : action.payload,
        status = _ref.status,
        statusText = _ref.statusText;
      state.error = {
        code: status || null,
        message: statusText || ((_action$error = action.error) === null || _action$error === void 0 ? void 0 : _action$error.message)
      };
      state.isLoading = false;
    }).addCase(ActionSearch.setQuery, function (state, _ref2) {
      var payload = _ref2.payload;
      state.query = payload;
    }).addCase(ActionSearch.setStep, function (state, _ref3) {
      var payload = _ref3.payload;
      state.step = payload;
    }).addCase(ActionSearch.toggleOpenSidebar, function (state, _ref4) {
      var payload = _ref4.payload;
      state.isOpenSidebar = payload;
    });
  }
});
export var search = searchSlice.reducer;